module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noIntegrations":"No integrations for your region"}}')
  delete Component.options._Ctor
}
